const getCurrentLang = i18n => {
  const options = [{ value: 'cs', label: 'CS' }, { value: 'en', label: 'EN' }];
  const currentLangKey =
    i18n.language.length > 2 ? i18n.language.substring(0, 2) : i18n.language;
  const selectedLang = options.find(item => item.value === currentLangKey);
  return selectedLang ? selectedLang : options[0];
};

export default getCurrentLang;



// WEBPACK FOOTER //
// lib/getCurrentLang.js